import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import {
  DetailsTableRow,
  InfoSvgIcon,
  TileSide,
  TileSideHeader,
} from '../../../components';
import Skeleton from 'react-loading-skeleton';
import { BodyText, Table, Tooltip, Link } from '@block-explorer/ui';
import { FlexColumn, InfoIcon, TableData } from '@make-software/cspr-design';
import { useCustomHistory } from '../../../router/utils';
import { CONTRACT_FEATURED_LIST_PATH } from '../../../router/paths';
import styled from 'styled-components';
import SectionTable from '../../../components/section-table/section-table';
import { SectionPaginationType } from '../../../components/section-table/section-table-pagination';
import { useGetRandomReshuffledFeaturedContracts } from '../hooks/use-get-random-reshuffled-featured-contracts';
import { FeaturedContractsRow } from './FeaturedContractsRow';

const TableContainer = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    padding: '0 20px',
  })
);

export const FeaturedContracts = () => {
  const { t } = useTranslation();
  const history = useCustomHistory();
  const {
    data: featuredContracts,
    loading,
    paginationProps,
    error,
  } = useGetRandomReshuffledFeaturedContracts();

  if (loading) {
    return (
      <TileSide>
        <FlexColumn gap={24}>
          <TileSideHeader title={<Trans t={t}>Featured Contracts</Trans>} />
          <Table
            renderData={() => (
              <DetailsTableRow>
                <TableData>
                  <FlexColumn gap={16}>
                    <Skeleton count={1} height={'88px'} width={'100%'} />
                    <Skeleton count={1} height={'28px'} width={'100%'} />
                    <Skeleton count={1} height={'70px'} width={'100%'} />
                  </FlexColumn>
                </TableData>
              </DetailsTableRow>
            )}
          />
        </FlexColumn>
      </TileSide>
    );
  }

  if (!featuredContracts || featuredContracts.length === 0) {
    return null;
  }

  return (
    <TileSide>
      <TileSideHeader
        title={<Trans t={t}>Featured Contracts</Trans>}
        justify={'space-between'}
        icon={
          <Tooltip
            tooltipContent={
              <Trans t={t}>
                Featured Contracts are curated, trusted projects in the Casper
                ecosystem.
              </Trans>
            }
          >
            <InfoSvgIcon src={InfoIcon} style={{ marginLeft: 6 }} size={20} />
          </Tooltip>
        }
      />
      <TableContainer>
        <SectionTable
          data={featuredContracts}
          loading={loading}
          error={error}
          paginationProps={paginationProps}
          renderPaginatedData={(featuredContracts) =>
            featuredContracts.map((featuredContract) => (
              <FeaturedContractsRow
                key={`featured-contract-${featuredContract.contract_package_hash}`}
                featuredContract={featuredContract}
              />
            ))
          }
          paginationType={SectionPaginationType.extendedPagination}
          footerLink={
            <Link
              color={'primaryBlue'}
              onClick={() => history.push(CONTRACT_FEATURED_LIST_PATH)}
            >
              <BodyText size={3} scale="sm" variation="blue" noWrap>
                <Trans t={t}>View all Featured Contracts</Trans>
              </BodyText>
            </Link>
          }
        />
      </TableContainer>
    </TileSide>
  );
};
